import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'CalloutIcon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Callout} from '@wandb/weave/components/Callout';
import React, {useMemo} from 'react';

import {trackWorkspaceModes} from '../../../../services/analytics/workspaceModesEvents';
import {lookupDocUrl} from '../../../../util/doc_urls';
import {useWorkspaceSettingsContext} from '../WorkspaceSettingsContextProvider';
import {getWorkspaceLayoutSettingWithDefaults} from './getWorkspaceLayoutSettings';

export const WorkspaceMode = () => {
  const {
    workspaceLayout,
    updateShouldAutoGeneratePanels,
    trackWorkspaceSettingChange,
  } = useWorkspaceSettingsContext();
  const {shouldAutoGeneratePanels} = useMemo(
    () => getWorkspaceLayoutSettingWithDefaults(workspaceLayout),
    [workspaceLayout]
  );

  if (shouldAutoGeneratePanels === 'pending') {
    return null;
  }

  return (
    <div className="rounded-lg border border-moon-250 px-24 py-16 text-center">
      <Callout
        className="mx-auto mb-8"
        size="x-small"
        icon={shouldAutoGeneratePanels ? 'automated-workspace' : 'draft'}
        color={shouldAutoGeneratePanels ? 'cactus' : 'purple'}
      />
      <p className="font-semibold">
        {shouldAutoGeneratePanels ? 'Automated workspace' : 'Manual workspace'}
      </p>
      <p className="mt-4 text-sm text-moon-600">
        Learn more about workspace modes{' '}
        <TargetBlank
          href={lookupDocUrl('workspaceModes')}
          onClick={() => {
            trackWorkspaceModes({
              action: 'Docs link clicked',
              location: 'Workspace settings drawer',
            });
          }}>
          in W&B docs
        </TargetBlank>
        .
      </p>
    </div>
  );
};
